const fr = {
  placeholderText: "Saisissez",
  closeContentText: "Terminer la conversation en cours ?",
  cancelText: "Annuler",
  okText: "ОК",
  loadingAnswerQuestions:
    "Traitement de votre question précédente. Merci de patienter avant d'envoyer.",
  networkAnomalyText: "Anomalie réseau. Veuillez réessayer ultérieurement.",
  errorText: "Erreur serveur",
  messageTooShort: "Vous devez saisir au moins deux caractères.",
  messageTooLong: "Ne doit pas dépasser 200 caractères.",
  systemErrorText: "​​Erreur système. Veuillez réessayer ultérieurement.​​",
  fileSizeExceeded: "Un fichier ne doit pas dépasser {maxSize}Mo.",
  abnormalDisconnectionText: "Connexion interrompue. Reconnexion en cours...",
  evaluationText: "Votre avis nous aide à nous améliorer !",
  emailLabel: "Adresse de messagerie​",
  emailPlaceholder: "Saisissez votre adresse électronique",
  emailErrorText: "Format d'email invalide.",
  productLabel: "Produit",
  productPlaceholder: "Choisissez un produit",
  problemLabel: "Description du problème",
  problemPlaceholder: "Décrivez votre problème en détail",
  submitText: "Envoyer",
  submitField: "Échec de l'envoi. Veuillez réessayer ultérieurement.",
  thankText:
    "Merci de votre coopération ! Nous vous contacterons dès que possible ! Veuillez vérifier vos e-mails ou {link}​ pour suivre les réponses !",
  clickHere: "cliquer ici​​​",
  thankEvaluation: "​​​Merci pour votre évaluation !",
  codeLabel: "Code de vérification",
  codePlaceholder: "Veuillez saisir le code de vérification",
  submittedSuccessfully: "Soumission réussie",
  supportContact: "Contact du support",
  stillCancel: "Annuler quand même",
  useDiscount: "Utiliser la réduction",
  pauseDuration: "Durée de pause",
  uploadAttachment: "Joindre un fichier",
};
export default fr;
